<!-- SCREENING IMAGES component -->
<template>
  <div id="imgBox" @click="toggleImgBox = !toggleImgBox">
    <!-- Display EXTERNAL Images -->
    <div v-if="toggleImgBoxVal == 'EXT'">
      <div class="imgGrid" v-show="toggleImgBox" style="height: 45vh; grid-template-columns: repeat(3, 175px)">
        <div v-for="(image, index) in getSignedImages.external" :key="index" class="md-layout-item" align="center">
          <drag :transfer-data="image" class="drag">
            <img
              :src="image.url"
              alt=""
              onerror="this.src='~/assets/img/noimage.jpg'"
              loading="lazy"
              @click="displayModal(image)"
            />
          </drag>
        </div>
      </div>
    </div>

    <!-- Display CORNEA Images -->
    <div v-else-if="toggleImgBoxVal == 'COR'">
      <div class="imgGrid" v-show="toggleImgBox" style="height: 45vh; grid-template-columns: repeat(2, 175px)">
        <div v-for="(image, index) in getSignedImages.cornea" :key="index" class="md-layout-item" align="center">
          <drag :transfer-data="image" class="drag">
            <img
              :src="image.url"
              alt=""
              onerror="this.src='~/assets/img/noimage.jpg'"
              loading="lazy"
              @click="displayModal(image)"
            />
          </drag>
        </div>
      </div>
    </div>

    <!-- Display PACHYMETRY Images -->
    <div v-else-if="toggleImgBoxVal == 'PAC'">
      <div class="imgGrid" v-show="toggleImgBox" style="height: 45vh; grid-template-columns: repeat(3, 185px)">
        <div v-for="(image, index) in getSignedImages.pachymetry" :key="index" class="md-layout-item" align="center">
          <drag :transfer-data="image" class="drag">
            <img
              :src="image.url"
              alt=""
              onerror="this.src='~/assets/img/noimage.jpg'"
              loading="lazy"
              @click="displayModal(image)"
            />
          </drag>
        </div>
      </div>
    </div>

    <!-- Display OPACITY Images -->
    <div v-else-if="toggleImgBoxVal == 'OPA'">
      <div class="imgGrid" v-show="toggleImgBox" style="height: 45vh; grid-template-columns: repeat(2, 175px)">
        <div v-for="(image, index) in getSignedImages.opacity" :key="index" class="md-layout-item" align="center">
          <drag :transfer-data="image" class="drag">
            <img
              :src="image.url"
              alt=""
              onerror="this.src='~/assets/img/noimage.jpg'"
              loading="lazy"
              @click="displayModal(image)"
            />
          </drag>
        </div>
      </div>
    </div>

    <!-- Display FUNDUS Images -->
    <div v-else-if="toggleImgBoxVal == 'FUN'">
      <div class="imgGrid" v-show="toggleImgBox" style="height: 45vh; grid-template-columns: repeat(4, 160px)">
        <div v-for="(image, index) in getSignedImages.fundus" :key="index" class="md-layout-item" align="center">
          <drag :transfer-data="image" class="drag">
            <img
              :src="image.url"
              alt=""
              onerror="this.src='~/assets/img/noimage.jpg'"
              loading="lazy"
              @click="displayModal(image)"
            />
          </drag>
        </div>
      </div>
    </div>

    <!-- Display MACULA Images -->
    <div v-else-if="toggleImgBoxVal == 'MAC'">
      <div class="imgGrid" v-show="toggleImgBox" style="height: 60vh; grid-template-columns: repeat(4, 170px)">
        <div v-for="(image, index) in getSignedImages.macula" :key="index" class="md-layout-item" align="center">
          <drag :transfer-data="image" class="drag">
            <img
              :src="image.url"
              alt=""
              onerror="this.src='~/assets/img/noimage.jpg'"
              loading="lazy"
              @click="displayModal(image)"
            />
          </drag>
        </div>
      </div>
    </div>

    <!-- Display NERVE Images -->
    <div v-else-if="toggleImgBoxVal == 'NRV'">
      <div class="imgGrid" v-show="toggleImgBox" style="height: 60vh; grid-template-columns: repeat(4, 170px)">
        <div v-for="(image, index) in getSignedImages.nerve" :key="index" class="md-layout-item" align="center">
          <drag :transfer-data="image" class="drag">
            <img
              :src="image.url"
              alt=""
              onerror="this.src='~/assets/img/noimage.jpg'"
              loading="lazy"
              @click="displayModal(image)"
            />
          </drag>
        </div>
      </div>
    </div>

    <!-- Display ALL Images -->
    <div v-else>
      <div class="imgGrid" v-show="toggleImgBox" style="height: 85vh; grid-template-columns: repeat(4, 145px)">
        <md-icon class="exit-icon2" @click.native="winModal = false">cancel</md-icon>
        <div v-for="(image, index) in getAllSignedImagesArray" :key="index" class="md-layout-item" align="center">
          <drag :transfer-data="image" class="drag">
            <img
              :src="image.url"
              alt=""
              onerror="this.src='~/assets/img/noimage.jpg'"
              loading="lazy"
              @click="displayModal(image)"
            />
          </drag>
        </div>
      </div>
    </div>

    <div v-show="false" class="md-layout">
      <drop class="drop" @drop="handleDrop">Dropzone</drop>
    </div>

    <!-- MODAL LARGE IMAGE -->
    <modal v-if="winModal">
      <template slot="body">
        <div class="wrapper" @click="winModal = false">
          <div>
            <span style="padding-bottom: 5px">{{ imgName }}</span>
            <md-icon class="exit-icon" @click.native="winModal = false">cancel</md-icon>
            <img :src="imgModal" height="150px;" width="auto" />
          </div>
        </div>
      </template>
    </modal>
  </div>
</template>

<script>
import { mapGetters } from "vuex"
import { Modal } from "@/components"
import { bus } from "@/main"

export default {
  name: "ScreeningImages",
  components: {
    Modal
  },

  props: {
    bus: [bus]
  },

  data() {
    return {
      winModal: false,
      imgModal: null,
      imgName: "",
      imgPrefix: process.env.VUE_APP_SCREENING_PACKAGES,
      toggleImgBox: false,
      toggleImgBoxVal: null,
      draggable: "Drag Me",
      odos: "ou"
    }
  },
  computed: {
    ...mapGetters(["IMGOBJ", "IMGARR", "getSignedImages", "getAllSignedImagesArray"]),
    mbrUsername: function () {
      return this.eval.patientInfo.email
    }
  },

  mounted: function () {
    bus.$on("toggleImgBox", (data) => {
      this.toggleImgBox = !this.toggleImgBox
      this.toggleImgBoxVal = data
      //console.log("TOGGLE: " + this.toggleImgBox, this.toggleImgBoxVal);
    })
  },

  methods: {
    handleDrop(data) {
      console.log(`You droppped: ${JSON.stringify(data)}`)
    },
    displayModal: function (img) {
      this.imgModal = img.url
      this.winModal = true
      this.imgName = img
      //console.log(img);
    }
  }
}
</script>

<style lang="scss" scoped>
#screeningassets {
  width: 98%;
  margin: 0px 0px 20px 0px;
  display: inline-block;
  vertical-align: top;
}

.drag,
.drop {
  font-family: sans-serif;
  display: inline-block;
  border-radius: 0px;
  background: #ccc;
  position: relative;
  padding: 0px;
  text-align: center;
  vertical-align: top;
}

.drag {
  min-width: 0;
  //color: #fff;
  //cursor: move;
  //background: rgb(0, 36, 112);
  //border-right: 2px solid #555;
  //border-bottom: 2px solid #555;
}

.drop {
  background: #eee;
  border-top: 2px solid #ccc;
  border-left: 2px solid #ccc;
}

.exit-icon {
  position: absolute;
  top: 0;
  right: 0;
  color: red !important;
  font-size: 28px !important;
  cursor: pointer;
  transform: translate(18px, -33px);
}

.exit-icon2 {
  position: absolute;
  color: white !important;
  font-size: 28px !important;
  cursor: pointer;
  transform: translate(565px, 10px);
}

.wrapper {
  position: relative;
  cursor: pointer;
}

.imgGrid {
  margin-top: 60px;
  //padding-top: 100px;
  //margin-bottom: 100px;
  //padding-bottom: 100px;

  cursor: move;

  position: fixed;
  z-index: 1000;
  background-color: rgba(0, 0, 0, 0.75);
  left: 55%;
  top: 45%;
  transform: translate(-50%, -50%);
  overflow-y: auto;
  overflow-x: auto;

  display: grid;
  grid-template-columns: repeat(4, 160px);
  justify-content: center;
  align-content: center;
  grid-gap: 10px;
  height: 20vh;
}

.imgGrid img {
  width: 100%;
  height: auto;
  cursor: pointer;
}

#imgBox {
  //display: none;
  //width: 100%;

  border-width: 35em;
  border-color: chartreuse;

  min-width: 0;
}

#lightbox {
  //position: fixed;
  //z-index: 1000;
  //top: 0;
  //width: 100%;
  //height: 100%;
  //background-color: rgba(0, 0, 0, .8);
  //display: none;
  min-width: 0;
}

#lightbox.active {
  //display: flex;
  //justify-content: center;
  //align-items: center;
  min-width: 0;
}

#lightbox img {
  //max-width: 90%;
  //max-height: 80%;
  //padding: 10px;
  //background-color: black;
  //border: 2px solid white;
  min-width: 0;
}
</style>
